// Home Hero / Campus Now에서 공유하는 시간 의미 정책.
// 화면별 문구는 각 consumer가 소유하지만, urgency threshold와 시간 포맷은 여기서만 정의한다.

export const HOME_CLASS_COUNTDOWN_MAX_MINUTES = 120
export const HOME_CLASS_IMMINENT_MAX_MINUTES = 15
export const HOME_CAMPUS_CLASS_SOON_MAX_MINUTES = 60
export const HOME_SHUTTLE_COUNTDOWN_MAX_MINUTES = 180
export const HOME_SHUTTLE_URGENT_MAX_MINUTES = 10
export const HOME_SHUTTLE_APPROACHING_MAX_MINUTES = 5

export const HOME_CLASS_TIMING_STATES = Object.freeze({
  ACTIVE: 'active',
  IMMINENT: 'imminent',
  COUNTDOWN: 'countdown',
  FAR_FIRST: 'far-first',
  FAR_NEXT: 'far-next',
  FINISHED: 'finished',
})

export function formatDuration(minutes) {
  if (minutes == null || !Number.isFinite(minutes)) return null
  if (minutes <= 0) return '곧'
  if (minutes < 60) return `${minutes}분`
  const hours = Math.floor(minutes / 60)
  const remainder = minutes % 60
  return remainder === 0 ? `${hours}시간` : `${hours}시간 ${remainder}분`
}

export function formatRelativeTime(minutes) {
  if (minutes == null || !Number.isFinite(minutes) || minutes < 0) return null
  const duration = formatDuration(minutes)
  return duration == null ? null : duration === '곧' ? duration : `${duration} 뒤`
}

export function resolveClassTimingState({ nowMin, startMin, endMin, hasPreviousClass = false } = {}) {
  if (!Number.isFinite(nowMin) || !Number.isFinite(startMin)) return null
  if (nowMin < startMin) {
    const remainingMinutes = startMin - nowMin
    if (remainingMinutes <= HOME_CLASS_IMMINENT_MAX_MINUTES) return HOME_CLASS_TIMING_STATES.IMMINENT
    if (remainingMinutes <= HOME_CLASS_COUNTDOWN_MAX_MINUTES) return HOME_CLASS_TIMING_STATES.COUNTDOWN
    return hasPreviousClass ? HOME_CLASS_TIMING_STATES.FAR_NEXT : HOME_CLASS_TIMING_STATES.FAR_FIRST
  }
  if (Number.isFinite(endMin) && nowMin < endMin) return HOME_CLASS_TIMING_STATES.ACTIVE
  return HOME_CLASS_TIMING_STATES.FINISHED
}

export function shouldShowShuttleCountdown(minutesLeft) {
  return Number.isFinite(minutesLeft) && minutesLeft > 0 && minutesLeft <= HOME_SHUTTLE_COUNTDOWN_MAX_MINUTES
}
